import * as React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../redux/user/actions.user';
import HeaderPartSeparator from '../HeaderPartSeparator/HeaderPartSeparator';
import billingStatusHelper from '../../../services/mini/billingStatusHelper';
import Money from '../../components/Money/Money';
import { IPlan } from '../../../models/IPlan';

type BalancePlateProps = {
    balance: number,
    freeInteractions: string,
    billingStatus: string, // todo: change billingStatus to enum
    hasPaymentInfo: boolean,
    currentPlan: IPlan
    memberOf: string
};

export function BalancePlate({
    balance,
    freeInteractions,
    billingStatus,
    hasPaymentInfo,
    currentPlan,
    memberOf
}: BalancePlateProps) {
    const { caseName, message } = billingStatusHelper(billingStatus, memberOf);

    if (memberOf) {
        return <div
            title={`Organization: ${memberOf}`}
            className={`balance-plate ${hasPaymentInfo && 'has-payment-info'} ${caseName}`}>
            <span className="balance-plate_org-name">
                {memberOf}
            </span>
        </div>;
    }

    return <div className={`balance-plate ${hasPaymentInfo && 'has-payment-info'} ${caseName}`}>
        {(currentPlan?.isEnterprise || currentPlan?.isPeriodic) ?
            <span className="balance-plate_plan-name">
                {`${currentPlan?.name} PLAN`}
            </span> :
            <React.Fragment>
                <span>
                    <span className="balance-plate_amount">
                        <Money
                            currency={<span className="balance-plate_currency">$</span>}
                            amount={balance} />
                    </span>
                </span>
                <HeaderPartSeparator height={24} marginLeft={6} marginRight={6} />
                <span className="balance-plate_amount">
                    {freeInteractions}
                </span>&nbsp;<span className="balance-plate_amount_label">
                    Free Interactions{caseName && <i className="icon icon-alan-info-sign" title={message} />}
                </span>
            </React.Fragment>}
    </div>;
}


function mapStateToProps({ user }) {
    return {
        balance: user.balance,
        billingStatus: user.billingStatus,
        freeInteractions: user.freeInteractions,
        hasPaymentInfo: user.hasPaymentInfo,
        currentPlan: user.currentPlan,
        memberOf: user.memberOf,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getUserBalance: () => dispatch(actions.getUserBalance()),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BalancePlate);